import React, { useState, useEffect, useCallback } from 'react';
import { TabBar, ListView } from 'antd-mobile';
import { useHistory, useParams } from 'react-router-dom';
import { useUserStatus } from '../../common/hooks/user-status'
import unmy from '../../assets/my-unselected.png';
import my from '../../assets/my.png';
import unme from '../../assets/meeting_unselected.png';
import meeting from '../../assets/meeting.png';
import { api } from '../../common/app';

export default (props: any) => {
  const { tabs, meetid, refreshProps } = props;

  const history = useHistory();
  // 是否隐藏 tabbar
  const [hidden, setHidden] = useState(false);
  // 选中tab
  const [selectedTab, setSelectedTab] = useState('home');

  const [mineData, setMineData] = useState("");
  const checkBar = () => {
    const withoutBarRoute = [
      '/home/register',
      '/home/hotel',
      '/home/plain',
      '/home/joruney',

      '/mine/register',
      '/mine/hotel',
      '/mine/plain',
      '/mine/joruney',
      '/mine/trip',
      '/mine/plane',
      '/mine/meet',
      '/pay/'
    ];
    const checkArray = withoutBarRoute.map((item) => {
      return window.location.href.indexOf(item)
    });
    if (checkArray.some((i) => i > -1)) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  }

  useEffect(() => {
    window.addEventListener("popstate", checkBar, false);
    return () => window.removeEventListener('popstate', checkBar)
  }, []);

  useEffect(() => {
      (api as any)
          .getUserInfoIndex({ meetid })
          .then((result: any) => {
              if (result.code === 200) {
                  setMineData(result.result);
              }
          })
  }, []);

  useEffect(() => {
    const { href } = window.location;
    if (href.indexOf('/home/') > -1) {
      setSelectedTab('home');
    } else if (href.indexOf('/mine/') > -1) {
      setSelectedTab('mine');
    }
  }, [window.location.href]);

  useEffect(() => {
    // 不需要tabbar的页面
    checkBar();
  }, [window.location.href]);

  const onTabClick = (item: any) => {
    console.log('meetid', meetid);
    console.log('/${item.route}/${meetid}', `/${item.route}/${meetid}`);
    history.push(`/${item.route}/${meetid}`);
    setSelectedTab(item.tab);
  };
  return (
    <div id='tab-contaienr' style={{ paddingBottom: 50, ...hidden? {height: '100%'} : {}, backgroundColor: hidden ? '#fff' : ''}}>
      <TabBar
        unselectedTintColor="#949494"
        tintColor="#33A3F4"
        barTintColor="white"
        hidden={hidden}
      >
        {tabs.map((item: any, index: any) => {
          const { Component } = item;
          return (
            <TabBar.Item
              key={index}
              title={item.title}
              icon={
                <div
                  style={{
                    width: '22px',
                    height: '22px',
                    background: `url(${item.tab === 'home' ? unme : unmy}) center center /  21px 21px no-repeat`
                  }}
                />
              }
              selectedIcon={
                <div
                  style={{
                    width: '22px',
                    height: '22px',
                    background: `url(${item.tab === 'home' ? meeting : my}) center center /  21px 21px no-repeat`
                  }}
                />
              }
              selected={selectedTab === item.tab}
              onPress={() => {
                console.log("mineData", mineData);
                if (item.tab === 'mine') {
                  (api as any)
                    .getUserInfoIndex({ meetid })
                    .then((result: any) => {
                      if (result.code !== 200) {
                        history.push(`/home/register/${meetid}`);
                        return;
                        } 
                    });
                }
                onTabClick(item);
              }}
            >
              {/* {[1, 2, 3].map(num => {
                return (
                  <div style={{ width: '100%', height: 400 }} >
                    {num}
                  </div>
                )
              })} */}
              {/* <ListView
                dataSource={new ListView.DataSource({ rowHasChanged: (r1: any, r2: any) => r1 !== r2, })}
                renderRow={() => <div />}
                renderFooter={() => {
                  return <Component setHidden={setHidden} />
                }}
              /> */}
              <Component setHidden={setHidden} refreshProps={refreshProps} />
            </TabBar.Item>
          )
        })}
      </TabBar>
    </div>
  )
}